/**
 * Conditions d’accès Patrimonea (FormApat — salaire / revenu mensuel).
 * Revenu mensuel net minimum : 500 000 FCFA.
 */
export const MIN_REVENU_MENSUEL_NET_FCFA = 500_000;

export function meetsMinRevenuMensuel(value) {
  const n = Number(value);
  return Number.isFinite(n) && n >= MIN_REVENU_MENSUEL_NET_FCFA;
}

export function formatMinRevenuMensuelLabel() {
  return `${MIN_REVENU_MENSUEL_NET_FCFA.toLocaleString('fr-FR')} FCFA`;
}
